<template>
  <div class="order-item-container">
    <div class="top">
      <div class="user-info">
        <div class="name">昵称：{{wechatName}}</div>
        <!-- <div class="mobile">{{custMobile}}</div> -->
      </div>
      <div class="pay-info">{{payTypeName}}</div>
    </div>
    <div class="mid">
      <div class="pay-price">金额：{{totalprice}}</div>
      <div class="pay-time">{{payTime}}</div>
    </div>
    <div class="bottom">
      <div class="pay-no" v-if="ordersn">
        编号：{{ordersn}}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderItem",
  props: {
    createDate:String,
    custId:Number,
    custMobile:String,
    deliveryFee:Number,
    id:Number,
    orderType:Number,
    ordersn:String,
    pay:Number,
    payTime:String,
    payType:Number,
    pstatus:Number,
    shopid:Number,
    totalcount:Number,
    totalprice:Number,
    wechatName:String,
    wechatUrl:String
  },
  computed: {
    // 计算属性的 getter
    payTypeName: function () {
      let name
      if (this.payType == 0) {
        name = '扫码收银'
      }else if(this.payType == 1){
        name = '门店订单'
      }
      return name
    }
  }
};
</script>

<style lang="scss">
.order-item-container{
  display: flex;
  flex-direction: column;
  margin: 1rem 0.5rem 0 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  box-shadow: 2px 2px 5px #dedede;
  .top{
    display:flex;
    justify-content: space-between;
    align-items: center;
    .user-info{
      text-align: left;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 2rem;
      .mobile{
        margin-left: 1rem;
      }
      .name{
        width: 140px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .pay-info{
      border: 1px solid #ff3366;
      color: #ff3366;
      border-radius: 4px;
      padding: 2px 4px;
    }
  }
  .mid{
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
  }
  .bottom{
    display: flex;
    justify-content: space-between;
  }
}
</style>
